module.exports = __webpack_public_path__ + "static/media/img31.60f43388.jpg";